import React, {useState, useContext} from 'react';
import PropTypes from 'prop-types';
import {Input, PageHeader} from 'antd';

import {TeamOutlined} from '@/icons';
import UserTabPane from './tabPane/UserTabPane';
import MsgContext from '@/page/customer/WelcomPage/msgContext';

const TABS = {
    userTab: {key: 'userTab', tab: '员工', icon: <TeamOutlined />, component: UserTabPane},
};

export default function MainPanel({onAddSelected, selectUserId}) {
    const {sendType} = useContext(MsgContext);

    const tabs = [];

    tabs.push(TABS.userTab);

    // 用于记录输入时查询框的值
    const [searchValue, setSearchValue] = useState(null);
    // 用于记录查询框最终值，之所以分为 2 个，是为了防止输入时候随时查询
    const [finalSearchValue, setFinalSearchValue] = useState(null);

    function onSearchChange(e) {
        setSearchValue(e.target.value);
    }

    function onSearch(value) {
        setFinalSearchValue(value);
    }

    function clearSearchValue() {
        setSearchValue(null);
        setFinalSearchValue(null);
    }

    function getExtraProps(key) {
        return {
            searchValue: finalSearchValue,
            clearSearchValue,
            parentUserId: selectUserId,
            userType: sendType,
        };
    }

    function renderSearch() {
        return null;
        // let placeholder = '按姓名、手机号、Email查询';
        // return (
        //     <Input.Search
        //         allowClear
        //         style={{width: 300}}
        //         placeholder={placeholder}
        //         value={searchValue}
        //         onChange={onSearchChange}
        //         onSearch={onSearch}
        //     />
        // );
    }

    return (
        <div style={{flex: 'auto', flexDirection: 'row'}}>
            <PageHeader />
            <UserTabPane onAddSelected={onAddSelected} {...getExtraProps('userTab')} />
        </div>
    );
}

MainPanel.propTypes = {
    selectUserId: PropTypes.string,
    onAddSelected: PropTypes.func.isRequired,
};
